/* unplugin-vue-components disabled */import script from "./VideoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoBase.vue?vue&type=script&setup=true&lang=js"

import "./VideoBase.vue?vue&type=style&index=0&id=64f8afee&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f8afee"]])

export default __exports__